var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h2',{staticClass:"mb-5"},[_vm._v("年末年始営業内容のお知らせ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.logi-co.co.jp/pdf/20191213_nen.pdf","target":"#"}},[_vm._v("\n    年末年始営業内容のお知らせ\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f2fda1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maintenance.vue
// module id = null
// module chunks = 